import axios from "axios";

// Prefer env override. Otherwise:
// - in development: use local backend
// - in production build: use production backend
// Note: trim() avoids accidental leading/trailing spaces breaking requests.
const DEFAULT_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4001/api"
    : "https://navimumbaigardenbackend.amcfest.in/api";

const API_BASE_URL = (process.env.REACT_APP_API_URL || DEFAULT_BASE_URL).trim();
// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor - Add token to headers
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRequest = error.config?.url?.includes("/login");
    if (error.response?.status === 401 && !isLoginRequest) {
      // Token expired or invalid
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;

